import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Thumbs } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/thumbs';

const ThumbSlider = ({ onThumbsReady, slides }) => {
    return (
        <div className="thumb-custom">
            <Swiper
                modules={[Thumbs]}
                onSwiper={onThumbsReady}
                spaceBetween={24}
                slidesPerView={5}
                freeMode={true}
                loop={true}
                watchSlidesProgress={true}
                className="thumbs-swiper"
                breakpoints={{
                    0: { slidesPerView: 1 },
                    768: { slidesPerView: 3 },
                    1200: { slidesPerView: 5 },
                }}
            >
                {slides.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <div className="thumb">{slide.thumb}</div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default ThumbSlider;
